import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getYearFromTimestamp } from '../../utils/timestamp';
import { useKeyPressEnter } from './hook';

import Tooltip from '../Tooltip';
import './styles.css';

const BasicDataPod = ({
  header,
  footer,
  tooltip,
  tooltipHeader,
  children,
  CustomTooltipIcon,
  className,
  ariaLabel,
}) => {
  const lastUpdatedYear = getYearFromTimestamp(footer);
  const podRef = useRef();
  const tooltipRef = useRef();

  useKeyPressEnter(podRef);

  return (
    <div
      className={classNames('basic-data-pod-container', className)}
      data-message=""
      tabIndex="0"
      ref={podRef}
    >
      <div
        className={`basic-data-pod-heading ${CustomTooltipIcon ? 'custom-icon' : ''}`}
        aria-label={ariaLabel}
      >
        <h2 className="basic-data-pod-title">{header}</h2>
        {tooltip && (
          <Tooltip
            className="heading-tooltip"
            contentHeader={tooltipHeader || header}
            contentText={tooltip}
            showCloseBtn
            onClose={() => {
              tooltipRef.current.focus();
            }}
          >
            {CustomTooltipIcon ? (
              <i
                tabIndex="0"
                aria-label="Tooltip"
                ref={tooltipRef}
                className="heading-tooltip-icon-custom"
              >
                <CustomTooltipIcon className="heading-tooltip-icon-custom" />
              </i>
            ) : (
              <i
                className="info circle icon heading-tooltip-icon"
                tabIndex="0"
                aria-label="Tooltip"
                ref={tooltipRef}
              />
            )}
          </Tooltip>
        )}
      </div>
      <div className="basic-pod-children">{children}</div>
      {lastUpdatedYear && (
        <div className="basic-data-pod-footer">{`from ${lastUpdatedYear}`}</div>
      )}
    </div>
  );
};

BasicDataPod.propTypes = {
  header: PropTypes.string, // Optional
  tooltip: PropTypes.any, // Optional
  footer: PropTypes.string, // Optional
  tooltipHeader: PropTypes.string, // Optional
  CustomTooltipIcon: PropTypes.object, // Optional
  className: PropTypes.string, // Optional
  ariaLabel: PropTypes.string, // Optional
};

export default BasicDataPod;
